import {
	SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_INTERACTIVE_LIGHT,
	SYS_SPACE_FIXED_200,
} from '@oneaudi/unified-web-common';

import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const ItemListStyle = styled.div<{ hasImage?: boolean }>`
	width: 100%;
	display: flex;
	position: relative;
	gap: ${({ hasImage }) => (hasImage ? '24px' : '0')};
	flex-direction: column-reverse;

	${breakPoints({
		'768': `
			flex-direction: row;
			gap: 48px;
		`,
	})}

	.details-wrapper {
		flex: 2;
	}

	.image-container {
		${breakPoints({
			'768': `
				width: 250px;
				height: 140px;
			`,
		})}
		img {
			aspect-ratio: 16 / 9;
			object-fit: cover;
			width: 100%;
		}
	}

	&.is-selected {
		border: 2px solid ${SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_INTERACTIVE_LIGHT};
	}

	.equipment-content {
		display: flex;
		padding: ${SYS_SPACE_FIXED_200};
		gap: 12px;
		flex-direction: column;
		height: 100%;

		.more-info {
			margin-top: auto;
			width: fit-content;
		}
	}

	.disclaimer-wrapper {
		margin-top: 4px;
	}
	.loading-skeleton {
		position: absolute;
		inset: 0;
		display: grid;
		place-items: center;
		background-color: rgba(255, 255, 255, 0.9);
	}
`;
